import { service } from '../index.js'

// 数据统计
export const admin = {
  // 获取统计数据
  getStats: () => {
    return service.get('/else/stats')
  },
  
  // 获取近7天订单趋势
  getOrderTrend: () => {
    return service.get('/else/order-trend')
  },
  
  // 获取最新订单
  getRecentOrders: (limit = 10) => {
    return service.get('/order/admin/list', { params: { pageSize: limit } })
  },
  
  // 获取热门商品
  getHotProducts: (limit = 10) => {
    return service.get('/product/hot', { params: { limit } })
  },
  
  // 获取热门设计
  getHotDesigns: (limit = 10) => {
    return service.get('/design/hot', { params: { limit } })
  },

  // ========== 小程序用户管理 ==========

  // 获取小程序用户列表
  getMiniUserList: (params) => {
    return service.get('/else/user/list', { params })
  },

  // 获取单个小程序用户
  getMiniUser: (id) => {
    return service.get(`/else/user/${id}`)
  },

  // 更新小程序用户
  updateMiniUser: (id, data) => {
    return service.put(`/else/user/${id}`, data)
  },

  // 删除小程序用户
  deleteMiniUser: (id) => {
    return service.delete(`/else/user/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/admin.js